import { render, staticRenderFns } from "./DateView.vue?vue&type=template&id=56ed73be&scoped=true"
import script from "./DateView.vue?vue&type=script&lang=js"
export * from "./DateView.vue?vue&type=script&lang=js"
import style0 from "./DateView.vue?vue&type=style&index=0&id=56ed73be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ed73be",
  null
  
)

export default component.exports